// extracted by mini-css-extract-plugin
export default {"Button":"Button_Button__QWXom","main":"Button_main__pA8zI","secondary":"Button_secondary__7fLYf"};